export default __webpack_public_path__ + "static/media/osm-pin.e2ce8fa5.svg";